import type { ReactNode } from "react";

import { VStack, Text } from "@whoosh/design-system/src/components/primitive";

type SpecialRequestSectionProps = {
  title: string;
  content: ReactNode;
};

export const SpecialRequestSection = ({
  title,
  content,
}: SpecialRequestSectionProps) => (
  <VStack gap={2}>
    <Text variant="mainBaseSemiBold" color="text-primary">
      {title}
    </Text>
    {content}
  </VStack>
);
